import type { NavigationItem } from "@app/types/Navigation";
import { sectionNavigationItems } from "@util/constant";

const navigationItems: NavigationItem[] = [
  { ...sectionNavigationItems["breaking-news"], label: "Breaking" },
  sectionNavigationItems.singapore,
  sectionNavigationItems.international,
  { ...sectionNavigationItems["companies-markets"], label: "Companies" },
  sectionNavigationItems.property,
  { ...sectionNavigationItems["startups-tech"], label: "Startups" },
  { ...sectionNavigationItems["opinion-features"], label: "Opinion" },
  sectionNavigationItems.lifestyle,
  sectionNavigationItems["bt-luxe"],
];

const navigationItemsRight: NavigationItem[] = [
  sectionNavigationItems.newsletter,
  { ...sectionNavigationItems.epaper, label: "Epaper" },
];

export { navigationItems, navigationItemsRight };

export const navigationConstant = [
  {
    section: {
      key: "navigation-left",
      children: navigationItems.map((navItems) => {
        return {
          ...navItems,
          children:
            navItems.children?.map((navItemsChildren) => {
              return sectionNavigationItems[navItemsChildren];
            }) || [],
        };
      }),
    },
  },
  {
    section: {
      key: "navigation-right",
      label: "Section",
      children: navigationItemsRight.map((navItems) => {
        return {
          ...navItems,
          children:
            navItems.children?.map((navItemsChildren) => {
              return sectionNavigationItems[navItemsChildren];
            }) || [],
        };
      }),
    },
  },
];
